import { Position } from './position';
import { Tracker } from './tracker';

export class Panic {
    id: number;
    tracker_id:number;
    
    initDate:Date;
    status:string;
    endDate:Date;
    finalDate:Date;
    panic_raw:string;
    active:boolean;

    position:Position;
    tracker:Tracker;

    constructor (id:number, tracker_id:number, initDate:Date, status:string, endDate:Date, finalDate:Date, panic_raw:string, active:boolean) {
        this.id = id;
        this.tracker_id = tracker_id;
        this.initDate = initDate;
        this.status = status;
        this.endDate = endDate;
        this.finalDate = finalDate;
        this.panic_raw = panic_raw;
        this.active = active;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/panic.ts